import { inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ApiService } from './api.service';
export const asBuiltVersionGuard:CanActivateFn=(route)=>{
  const api=inject(ApiService),router=inject(Router),http=inject(HttpClient);
  if(!api.isAuthenticated())return router.parseUrl('/login');
  const role=String(api.currentUser()?.role || '');
  if(!['Drainlayer','Admin'].includes(role))return router.parseUrl('/');
  const v2=route.routeConfig?.path?.startsWith('as-built-v2');
  return http.get<any>(`${api.baseUrl}/as_built_v2/index.php?action=settings`,{headers:new HttpHeaders({Authorization:`Bearer ${api.accessToken()}`})}).pipe(
    map(res=>{
      if(res?.data?.admin)return true;
      const enabled=!!res?.data?.staff_enabled;
      return enabled===!!v2?true:router.parseUrl(enabled?'/as-built-v2':'/as-built');
    }),
    catchError(()=>of(v2?router.parseUrl('/as-built'):true))
  );
};
